import { render, staticRenderFns } from "./TiptapOutput.vue?vue&type=template&id=763bbaf4&scoped=true&"
import script from "./TiptapOutput.vue?vue&type=script&lang=js&"
export * from "./TiptapOutput.vue?vue&type=script&lang=js&"
import style0 from "./TiptapOutput.vue?vue&type=style&index=0&id=763bbaf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763bbaf4",
  null
  
)

export default component.exports